export { default } from "./LegacyOfTaste";



// WEBPACK FOOTER //
// ./src/components/LegacyOfTaste/index.js